const types = {
    SET_CREDIT_TYPE: "SET_CREDIT_TYPE",
    SET_CREDIT_TIME: "SET_CREDIT_TIME",
    SET_CREDIT: "SET_CREDIT"
};

const state = {
    creditSelected: 'Crédito MIPYME',
    credit: 5000,
    creditTypes: ['Crédito MIPYME'],
    time: 1,
    monthlyPayment: 6974.30
};

const actions = {
    setCreditType({ commit }, type) {
        commit(types.SET_CREDIT_TYPE, type);
    },
    getMonthlyPayment({ commit }, params) {
        commit(types.SET_CREDIT_TIME, params.time);
        commit(types.SET_CREDIT, params.credit);
    }
}

const mutations = {
    [types.SET_CREDIT_TYPE](state, type) {
        state.creditSelected = type;
    },
    [types.SET_CREDIT_TIME](state, time) {
        state.time = time;
    },
    [types.SET_CREDIT](state, credit) {
        state.credit = credit;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
